import { bookLookup, formatName, ingramUnitsCovered } from "./salesReporting";

export function ingramPeriods(reports, compensation) {
  const periods = new Map();
  [...reports, ...compensation].forEach(report => periods.set(`${report.start}|${report.end}`, { start: report.start, end: report.end }));
  return [...periods.values()].sort((a, b) => b.end.localeCompare(a.end) || b.start.localeCompare(a.start));
}

export function ingramSummary(reports, compensation, period, catalog = []) {
  const rows = new Map(); const royalties = {}; const titleFor = bookLookup(catalog);
  let units = 0; let hasUnits = false; let returns = 0;
  const royaltyPeriods = new Set();
  function rowFor(record) {
    const title = titleFor(record.book_title, record.isbn); const format = formatName(record.format);
    const key = `${record.isbn || title}|${format}`;
    if (!rows.has(key)) rows.set(key, { key, isbn: record.isbn, title, format, countries: new Set(), units: null, returns: 0, royalties: {} });
    return rows.get(key);
  }
  reports.filter(report => report.start >= period.start && report.end <= period.end).forEach(report => {
    hasUnits = true; units += Number(report.total_units);
    report.records.forEach(record => {
      const row = rowFor(record); row.units = (row.units ?? 0) + Number(record.units_sold);
      if (record.country) row.countries.add(record.country);
    });
  });
  compensation.filter(report => report.start >= period.start && report.end <= period.end).forEach(report => {
    royaltyPeriods.add(`${report.start} to ${report.end}`);
    report.records.forEach(record => {
      const covered = ingramUnitsCovered(reports, report, record);
      const row = rowFor(record); const returned = Number(record.units_refunded || 0);
      row.returns += returned; returns += returned;
      if (!covered) { hasUnits = true; units += Number(record.net_units); row.units = (row.units ?? 0) + Number(record.net_units); }
      const micros = Math.round(Number(record.compensation) * 1000000);
      row.royalties[record.currency] = (row.royalties[record.currency] || 0) + micros;
      royalties[record.currency] = (royalties[record.currency] || 0) + micros;
      if (record.market) row.countries.add(record.market);
    });
  });
  const amounts = values => Object.fromEntries(Object.entries(values).map(([currency, micros]) => [currency, micros / 1000000]));
  return { units: hasUnits ? units : null, returns, royalties: amounts(royalties), royaltyPeriods: [...royaltyPeriods],
    rows: [...rows.values()].map(row => ({ ...row, countries: [...row.countries].join(", "), royalties: amounts(row.royalties) })).sort((a, b) => a.title.localeCompare(b.title) || a.format.localeCompare(b.format)) };
}
